<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-50 flex justify-center bg-black/60 ">
      <div class="m-5  w-full md:w-9/12 lg:w-6/12 h-max-[90vh] overflow-y-auto" @click.self="closeDialog(false)">

        <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">

          <div class="flex flex-col w-full text-black">

            <BlockUI :visible="blocked">

              <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
                <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent"
                  animationDuration=".5s" />
              </div>

              <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
                <div>
                  <font-awesome-icon :icon="['far', 'fa-clock']" class="w-6 h-6 text-white" />
                </div>
                <div
                  class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis">
                  {{ $t('titulo.pedir.cita') }}
                </div>
                <div
                  class="text-white text-sm md:text-xl truncate whitespace-nowrap overflow-hidden text-ellipsis uppercase"
                  v-if="itemMeetingSeleccionado.empresa">
                  {{ itemMeetingSeleccionado.empresa.nombreFantasia || $t('label.sin.empresa') }}
                </div>
              </div>

              <div class="w-full p-4 text-left " >
                <NavPill :items="fechas" v-model="fechaSeleccionada" :onChange="onChangeFechaCronograma" />

                <DataView :value="cronogramasUnicos" paginator :rows="18" :alwaysShowPaginator="false" dataKey="item.id"
                  class="!bg-transparent">
                  <template #empty>
                    <div v-if="blocked">
                      <div
                        class="w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500">
                        {{ $t('label.cargando') }}
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500">
                        {{ $t('label.no.hay.mas.horarios') }}
                      </div>
                    </div>
                  </template>
                  <template #list="slotProps">
                    <div
                      class="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-2 mt-4 text-gray-700 text-xs md:text-sm content-start">
                      <div v-for="(item) in slotProps.items" :key="item.id">
                        <a @click="seleccionarCita(item)"
                          :class="item.id == citaSeleccionada?.id ? 'bg-[#424c42] text-white' : 'bg-white'"
                          class="w-full flex flex-row text-sm items-center justify-center py-3 border border-gray-600 text-black shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[103%] cursor-pointer">
                          <font-awesome-icon :icon="['far', 'fa-clock']" class="relative top-[2px] mr-1" />
                          <span class="font-bold">{{ item.horaDesde }}</span>
                        </a>
                      </div>
                    </div>
                  </template>

                </DataView>

                <div
                  class="w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4">
                  {{ $t('label.acreditados.disponibles') }}
                </div>

                <div
                  class="w-full grid grid-cols-1 md:grid-cols-2 gap-2 mt-4 text-gray-700 text-xs md:text-sm content-start">
                  <div v-for="(item, i) in acreditadosDisponibles" :key="i"
                    @click="acreditadosHabilitados.includes(item.id) && seleccionarAcreditado(item)" :class="[
                      'w-full flex flex-row md:flex-col items-center md:justify-center p-3 border border-gray-600 shadow-md rounded-xl transform transition-transform duration-200',
                      // Habilitado / Deshabilitado
                      acreditadosHabilitados.includes(item.id)
                        ? 'cursor-pointer hover:scale-[101%]'
                        : 'opacity-40 cursor-not-allowed',
                      // Seleccionado
                      item.id === acreditadoSeleccionado?.id
                        ? 'bg-[#424c42] text-white'
                        : 'bg-white'
                    ]">
                    <!-- FOTO -->
                    <div class="flex-shrink-0">
                      <img v-if="item.foto" :src="item.foto"
                        class="w-12 h-12 rounded-full border border-[#bbc1a9] object-cover bg-white" />
                      <div v-else class="w-12 h-12 rounded-full border border-[#bbc1a9] bg-gray-300"></div>
                    </div>
                    <!-- TEXTO -->
                    <div class="flex flex-col justify-center md:text-center ml-3 md:ml-0">
                      <div class="font-sm font-semibold leading-tight">{{ item.nombre }}</div>
                      <div class="font-sm font-semibold leading-tight">{{ item.apellido }}</div>
                    </div>
                  </div>
                </div>

                <div class="w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4">
                    {{ $t('label.motivo.cita') }}
                </div>

                <Field name="motivoCita" v-slot="{ field, errors }" v-model="motivoCita">
                  <Textarea v-bind="field" rows="4" type="text" :placeholder="$t('label.ingres.motivo.cita')" class="input-base w-full border border-gray-300 py-2 pl-2 pr-2 text-gray-500 !shadow-md rounded-xl mt-4" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
                </Field>

              </div>

              <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100">
                <a @click="tomarCita" class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-check-double']" /> {{ $t('boton.tomar.cita') }}
                </a>
                <a @click="closeDialog(false)" class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cancelar') }}
                </a>
              </div>
            </BlockUI>

          </div>
        </div>

      </div>
    </div>
  </Teleport>

</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Field } from 'vee-validate';

import Swal from 'sweetalert2'
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';
import Textarea from 'primevue/textarea';

import { Acreditado, ConfiguracionMeeting, Cronograma, Evento, ItemMeeting } from 'qreventos-suite/src/services/suite.interfaces';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import meetingService from 'qreventos-suite/meeting';
import NavPill from '@/components/commons/NavPill.vue';
import DataView from 'primevue/dataview';
import seguridadServices from '@/services/seguridad.services';

export default defineComponent({
  components: {
    Field,
    BlockUI, ProgressSpinner, DataView, Textarea,
    NavPill
  },
  props: {
    itemMeetingSeleccionado: {
      type: {} as PropType<ItemMeeting>,
      required: true
    },
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      blocked: false,
      citasDisponibles: [] as Cronograma[],
      citaSeleccionada: undefined as unknown as Cronograma,
      fechas: [] as string[],
      fechaSeleccionada: '',
      motivoCita: '',

      acreditadoSeleccionado: undefined as unknown as Acreditado,
      cronogramasUnicos: [] as Cronograma[],
      acreditadosDisponibles: [] as Acreditado[],
      acreditadosHabilitados: [] as number[],
    };
  },
  methods: {
    seleccionarCita(cronograma: Cronograma) {
      this.citaSeleccionada = cronograma;
      this.limpiarSeleccionAcreditado();

      this.acreditadosHabilitados = this.citasDisponibles.filter(c => c.horaDesde === cronograma.horaDesde).map(c => c.acreditado.id);
    },
    closeDialog(ok: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(ok);
      }
    },
    async fillFechasBy(evento: Evento) {
      this.fechas = await meetingService.findFechasBy(evento.id);
      this.fechaSeleccionada = this.fechas[0];
    },
    async onChangeFechaCronograma(fecha: string) {
      try {
        this.blocked = true;
        this.limpiarSeleccionAcreditado();

        this.citasDisponibles = [] as Cronograma[],
          this.fechaSeleccionada = fecha;
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        await this.fillCitasDisponibles(configuracionMeeting.evento);

   
      } catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.blocked = false;
      }
    },
    seleccionarAcreditado(acreditado: Acreditado) {
      this.acreditadoSeleccionado = acreditado;
    },
    limpiarSeleccionAcreditado() {
      this.acreditadosHabilitados = [];
      this.acreditadoSeleccionado = undefined as unknown as Acreditado;
    },
    async fillCitasDisponibles(evento: Evento) {
      const hash: string = seguridadServices.getLocalHash() as string;
      this.citasDisponibles = await meetingService.findCitasDisponiblesBy(evento.id, hash, this.fechaSeleccionada, this.itemMeetingSeleccionado);

      this.acreditadosDisponibles = Array.from(new Map(this.citasDisponibles.map(c => [c.acreditado.id, c.acreditado])).values());
      this.cronogramasUnicos = Array.from(new Map(this.citasDisponibles.sort((a, b) => a.horaDesde.localeCompare(b.horaDesde)).map(c => [c.horaDesde, c])).values());

     
    },
    async tomarCita() {
      try {
        if(!this.acreditadoSeleccionado){
          Swal.fire({ title: "Error", html: this.$t("errors.seleccione.acreditado"), icon: "error"});
          return;
        }

        if (!this.motivoCita ||this.motivoCita == ""){
          Swal.fire({ title: "Error", html: this.$t("errors.debe.ingresar.motivo.cita"), icon: "error"});
          return;
        }

        this.blocked = true;
        const hash: string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        let ok: boolean = await meetingService.reservarCita(configuracionMeeting.evento.id, hash, this.citaSeleccionada.id, this.acreditadoSeleccionado.id, this.motivoCita);
        if (ok == true) {
          this.closeDialog(true);
        }
      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    },
  },
  async mounted() {
    document.body.style.overflow = "hidden";

    try {
      this.blocked = true;
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      await this.fillFechasBy(configuracionMeeting.evento);
      await this.fillCitasDisponibles(configuracionMeeting.evento);

    } catch (error) {
      this.blocked = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.blocked = false;
    }
  },
  unmounted() {
    document.body.style.overflow = "";
  }
});
</script>